import { DBModel } from './DBModel';
import { TAGPermission } from './tagpermission';

export class TAGUser extends DBModel {
  username: string = '';
  firstname: string = '';
  lastname: string = '';
  password: string = '';
  pin: string = '';

  schoolclass: string = '';

  active: boolean = true;
  hidden: boolean = false;

  registerdate: Date = new Date();

  // Email
  email: string = '';
  technikEmail: string = '';
  technikEmailPassword: string = '';

  // Permissions
  permissions: Set<TAGPermission> = new Set<TAGPermission>();

  constructor(info: any = {}) {
    super();
    this.deserialize(info);
  }

  get fullname() {
    return this.firstname + ' ' + this.lastname;
  }

  hasPermission(permission: TAGPermission): boolean {
    return this.permissions.has(permission);
  }

  override serialize(): any {
    var obj: any = super.serialize();

    obj.username = this.username;
    obj.firstname = this.firstname;
    obj.lastname = this.lastname;
    obj.password = this.password;
    obj.pin = this.pin;

    obj.schoolclass = this.schoolclass;

    obj.active = this.active;
    obj.hidden = this.hidden;

    obj.registerdate = this.registerdate;

    obj.email = this.email;
    obj.technikEmail = this.technikEmail;
    obj.technikEmailPassword = this.technikEmailPassword;

    obj.permissions = Array.from(this.permissions).map((p) => p.name);

    return obj;
  }

  override deserialize(data: any) {
    super.deserialize(data);

    if (data.username != null) this.username = data.username;
    if (data.firstname != null) this.firstname = data.firstname;
    if (data.lastname != null) this.lastname = data.lastname;
    if (data.password != null) this.password = data.password;
    if (data.pin != null) this.pin = data.pin;

    if (data.schoolclass != null) this.schoolclass = data.schoolclass;

    if (data.active != null) this.active = data.active;
    if (data.hidden != null) this.hidden = data.hidden;

    if (data.registerdate != null) this.registerdate = new Date(data.registerdate);

    if (data.email != null) this.email = data.email;
    if (data.technikEmail != null) this.technikEmail = data.technikEmail;
    if (data.technikEmailPassword != null) this.technikEmailPassword = data.technikEmailPassword;

    if (data.permissions != null) {
      let knownPermissions = data.permissions.filter(
        (p: string) => TAGPermission.fromName(p) != undefined,
      );
      this.permissions = new Set(knownPermissions.map((p) => TAGPermission.fromName(p)));
    }
  }
}
